import LocationLoader from './LocationLoader';
import { LocationDetail } from 'hooks/useGetLocations';

type LocationProps = {
  className?: string;
  isLoading: boolean;
  location?: LocationDetail;
};

function Location({ className, isLoading, location }: LocationProps) {
  if (isLoading) {
    return <LocationLoader />;
  }

  if (location) {
    return (
      <div className={className} data-testid="location">
        <div>
          <span className="mr-1 text-2xl">{location.name},</span>
          <span>{location.region}</span>
        </div>
        <div className="text-sm">{location.country}</div>
      </div>
    );
  }

  return null;
}

export default Location;
